import { useSWRConfig } from "swr";
import React, { useState } from "react";
import FormModal from "../common/FormModal";
import { Form } from "react-bulma-components";
import { fetcher } from "../utils/fetch";

export default function AddShoppingItemForm({ onClose, project, show }) {
    const { mutate } = useSWRConfig();

    const [item, setItem] = useState();

    const onSubmit = async () => {
        try {
            await fetcher(`/api/projects/${ project.id }/shopping`, {
                method: 'POST',
                body: JSON.stringify({
                    item: item
                })
            });

            await mutate(`/api/projects/${ project.id }`);
        } catch (e) {
            // TODO: Check for validation errors
            // TODO: Check for catastrophic failures
            console.error('oops', e);
        }

        onClose();
    };


    return (
        <FormModal title="Add shopping item" onSubmit={ onSubmit } onClose={ onClose } show={ show }>
            <Form.Field horizontal>
                <Form.Field.Label>
                    <Form.Label>Item</Form.Label>
                </Form.Field.Label>
                <Form.Field.Body>
                    <Form.Field>
                        <Form.Control>
                            <Form.Input onChange={ e => setItem(e.currentTarget.value) }/>
                        </Form.Control>
                    </Form.Field>
                </Form.Field.Body>
            </Form.Field>
        </FormModal>
    )
}
